

class URLTagListsController

    ### @ngInject ###
    constructor: ($scope, TagService, $timeout) ->
        @TagService = TagService

        @tagLists = []
        @params = @TagService.getParamsFromUrl()
        changeTimeout = null

        @paramsChanged = =>
            $timeout.cancel(changeTimeout)
            changeTimeout = $timeout(@rebuildParams)

    getListParams: ->
        return (list.params for list in @tagLists)

    addTagList: (list) ->
        index = @tagLists.indexOf list
        if index == -1
            @tagLists.push list
            list.loadTags @params
        return

    removeTagList: (list) ->
        index = @tagLists.indexOf list
        @tagLists.splice(index, 1) if index >= 0
        return

    rebuildParams: =>
        @params = angular.extend({}, @getListParams()...)
        @TagService.paramsToUrl(@params)
        @onChange(params: @params)
        return


class TagFilterController

    ### @ngInject ###
    constructor: (TagService, $attrs, $parse, $scope, $analytics) ->
        @analytics = $analytics
        @TagService = TagService
        @urlLinked = TagService.hasUrlTags()
        @isOpen = false
        @tags = @tags or []
        @tagGroups = {}
        @tagLists = ['participant', 'program', 'location']
        @listLabels =
            participant: 'For students tagged'
            program: 'For programs tagged'
            location: 'Located in'

        if not @addTagLabel?
            @addTagLabel = 'Filter report by tags'

        if @program and @skipIfProgram
            @skip = if @skip then "#{@skip}.#{@skipIfProgram}" else @skipIfProgram

        if $attrs.controller?
            $parse($attrs.controller).assign($scope.$parent, @)

        @initializeTags() if @urlLinked

    track: (name, label) ->
        @analytics.eventTrack name,
            category: 'Tag Picker'
            label: label

    open: ->
        @isOpen = true
        @track 'open'
        return

    close: ->
        @isOpen = false
        @track 'close'
        return

    initializeTags: ->
        params = @TagService.getParamsFromUrl()
        if @program
            params.program_id = @program.id
        return @TagService.lookupTags(params).then (tags) =>
            @addTag(tag) for tag in tags
            @params = @buildParams()
            @onChange(params: @params)
            return tags

    lookupRawTag: (tag) ->
        params = {}
        params[tag.slug] = tag.value
        params.program_id = if @program then @program.id else undefined
        return @TagService.lookupTags(params).then (tags) => tags[0]

    addRawTag: (tag) ->
        @lookupRawTag(tag).then (tag) =>
            @addTag(tag)
            return tag

    addTag: (tag) ->
        @track 'add', "#{tag.slug}=#{tag.value}"
        @tagGroups[tag.tag_for] = @tagGroups[tag.tag_for] or []
        arrayAdd @tags, tag
        arrayAdd @tagGroups[tag.tag_for], tag
        @params = @buildParams()
        @onChange(params: @params)
        return

    removeTag: (tag) ->
        tag = @tags.find (t) -> t.slug == tag.slug and t.value == tag.value
        if not tag then return
        @track 'remove', "#{tag.slug}=#{tag.value}"
        @tagGroups[tag.tag_for] = @tagGroups[tag.tag_for] or []
        arrayRemove @tags, tag
        arrayRemove @tagGroups[tag.tag_for], tag
        @params = @buildParams()
        @onChange(params: @params)
        return

    buildParams: ->
        params = {}
        for tag in @tags
            params[tag.slug] = params[tag.slug] or []
            params[tag.slug].push tag.value
        @TagService.paramsToUrl(params) if @urlLinked
        return params

arrayRemove = (array, value) ->
    index = array.indexOf(value)
    array.splice(index, 1) if index >= 0
    return


arrayAdd = (array = [], value) ->
    index = array.indexOf(value)
    array.push value
    return

urlTagListDirective = ->
    restrict: 'E'
    scope: {}
    controller: URLTagListsController
    controllerAs: 'ctrl'
    bindToController:
        program: '='
        params: '='
        onChange: '&'


tagFilterDirective = ->
    restrict: 'E'
    templateUrl: 'util/tags/tagFilter'
    controller: TagFilterController
    controllerAs: 'ctrl'
    bindToController: true
    scope:
        program: '='
        params: '=?'
        tags: '=?'
        onChange: '&'
        skip: '@'
        skipIfProgram: '@'
        addTagLabel: '@'

module.directive 'dybUrlTagLists', urlTagListDirective
module.directive 'dybTagFilter', tagFilterDirective
